import StrikeThroughPrice from '@imageTheme/mobile/BlackFriday2023/BF2023-X.webp';
import Image from 'next/image';
import {priceHelper, returnHighestAndLowestPriceValues} from '@helpers/config-master.mjs';
import {LoadAffirmScript} from '@components/affirm/load-affirm-script';
import {useAllPrices} from '@components/product/desktop/PricingDesktop';
import {niceMoney} from '@helpers/common/number.mjs';
import {HStack, VStack} from '@components/widgets/Common';
import {InStockIndicator} from '@components/product/global/InStockIndicator';
import {useSession} from 'next-auth/react';
import {LightYellowBgBox} from '@components/form-fields/MessageBoxes';

export const PricesMobile = ({product}) => {
  // console.log("[PricesMobile][product]:", {product})
  const {data: session} = useSession();
  const user = session?.user;
  const isDealer = user?.isDealer;

  const selectedVariant = product?.selectedVariant ?? product;

  const allPrices = useAllPrices(selectedVariant);
  const salePrice = allPrices?.sale_price;
  const mapPrice = allPrices?.map_price;
  const msrpPrice = allPrices?.msrp_price;

  const salePriceValue = priceHelper.getFinalPrice(selectedVariant);
  const isSaleEnabled = priceHelper.saleEnabledFor(selectedVariant);

  const isDiscontinued = product?.isDiscontinued === true;

  if (isDealer) {
    return <DealerPricingMobile product={product} isDealer={isDealer}/>;
  }

  return (
    <HStack className="mb-1">
      <VStack className="flex" style={{width: '30%'}}>
        <InStockIndicator
          product={product}
          isDiscontinued={isDiscontinued}
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            verticalAlign: 'bottom'
          }}
        />
        <div className="text-gray-500 font-normal" style={{fontSize: '14px'}}>
          MSRP:
          <span className="ml-1 line-through">{niceMoney(msrpPrice)}</span>
        </div>

        {/*<div className='text-gray-900 -mt-1' style={{fontSize: '16px'}}>*/}
        {/*  Price:*/}
        {/*  <span className={cn('ml-1', {'line-through': isSaleEnabled})}>*/}
        {/*    {niceMoney(mapPrice)}*/}
        {/*  </span>*/}
        {/*</div>*/}

        <div className="text-gray-700 text-lg flex border-left relative">
          Price:
          <div className={'relative ml-1'}>
            {niceMoney(mapPrice)}
            <div className={'absolute top-1.5 left-1 opacity-55'}>
              <Image src={StrikeThroughPrice} alt="Strike Through Price"/>
            </div>
          </div>
        </div>
      </VStack>

      <VStack className="items-end" style={{width: '70%'}}>
        {/*<div className='text-gray-700 text-lg flex border-left relative'>*/}
        {/*  Price:*/}
        {/*  <div className={'relative ml-1'}>*/}
        {/*    {mapPrice}*/}
        {/*    <div className={'absolute top-1 left-1 opacity-80'}>*/}
        {/*      <Image src={StrikeThroughPrice} alt='Strike Through Price' />*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}

        {/*{isSaleEnabled && (*/} {/* !! NORMAL SALE PRICING !!*/}
        {/*  <div*/}
        {/*    style={{*/}
        {/*      fontWeight: 'bold',*/}
        {/*      fontSize: '20px',*/}
        {/*      paddingBottom: '3px',*/}
        {/*      color: '#0880A1',*/}
        {/*    }}>*/}
        {/*    <div className="align-items-end" style={{color: 'rgba(4,43,138, 1)'}}>*/}
        {/*      SALE PRICE:&nbsp;*/}
        {/*      <span style={{color: 'rgba(4,43,138, 1)'}}>*/}
        {/*        {niceMoney(salePrice)}*/}
        {/*      </span>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}

        {isSaleEnabled && (
          <div
            style={{
              fontWeight: 'bold',
              fontSize: '20px',
              paddingBottom: '2px',
            }}
          >
            <div className="flex items-end"
                 style={{
                   color: 'rgb(36,85,208)',
                   marginRight: '5px',
                   marginTop: '3px'
                 }}
            >
            <span className="inline-flex items-end">
              <span
                style={{
                  fontSize: '18px',
                  transform: 'rotate(-16.5deg) translate(-8px, -1px)', // Added translation
                  transformOrigin: 'bottom left',
                  display: 'inline-block',
                  marginRight: '-35px',
                  position: 'relative', // Added position relative
                }}
              >
                SUMMER SALES EVENT
              </span>
              <span style={{fontSize: '19px'}}>PRICE:&nbsp;</span>
            </span>
              <span style={{fontSize: '19px'}}>{niceMoney(salePrice)}</span>
            </div>
          </div>
        )}

        <div id="div-affirm" className={isSaleEnabled ? `my-0` : `basis-1/2`}>
          <LoadAffirmScript
            price={salePriceValue}
            style={{
              textAlign: 'right'
            }}
          />
        </div>
      </VStack>
    </HStack>
  );
};

export function DealerPricingMobile({product, isDealer}) {
  product = product?.selectedVariant || product;
  const priceDealer = product?.priceDealer ?? product?.price_dealer;
  const qtyInStockTPA = product?.tpa_wh ?? product?.inventory?.tpa_wh;
  const qtyInStockLV = product?.lv_wh ?? product?.inventory?.lv_wh;
  const [highPrice] = returnHighestAndLowestPriceValues(product, {isDealer});

  const lightYellowBgBoxStyle = {
    marginTop: '5px',
    width: '60%'
  };

  const inStockTextStyle = {
    paddingLeft: '5px',
    fontSize: '14.25px',
    marginTop: '-2px',
    textAlign: 'left'
  };

  const subTextStyle = {
    marginLeft: '10px',
    fontSize: '13.5px',
    fontWeight: '400',
    paddingLeft: '15px',
    textAlign: 'right',
    color: 'black'
  };

  const locationTextStyle = (color) => ({
    color: `rgba(${color},0.95)`,
    fontSize: '13.5px',
    fontWeight: '400',
    cursor: 'pointer'
  });

  return (
    <>
      <LightYellowBgBox style={lightYellowBgBoxStyle}>
        <span className="text-lime-600" style={inStockTextStyle}>
          In Stock:
          <span style={subTextStyle}>
            &nbsp;TPA: <span style={locationTextStyle('3,33,178')}>{qtyInStockTPA}</span>
          </span>
          <span style={subTextStyle}>
            &nbsp;LV: <span style={locationTextStyle('54,5,211')}>{qtyInStockLV}</span>
          </span>
        </span>
      </LightYellowBgBox>

      <div>
        <HStack className="mt-2 flex-wrap items-start content-end justify-between">
          <div className="flex items-center w-full">
            <div className="w-1/2 flex items-center">
              {/* Left-aligned content here */}
              <div className="text-gray-500 w-fit relative font-normal flex">
                MAP:
                <span className="ml-1">{niceMoney(highPrice)}</span>
                <div
                  style={{
                    borderTop: '1px solid gray',
                    width: '100%',
                    position: 'absolute',
                    top: '12px'
                  }}
                />
              </div>
            </div>
            <div className="w-1/2 flex items-center justify-end">
              {/* Right-aligned content here */}
              <div className="text-sky-800 text-lg fw-bold flex -mt-1">
                Dealer Price:
                <div className="ml-1">{niceMoney(priceDealer)}</div>
              </div>
            </div>
          </div>
        </HStack>
      </div>
    </>
  );
}
